import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/rout'

export const routService = {
    search,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    // getAll,
    // getPagedList,
    // getAllWithNameByUdn,
    getRoutByActivity,
};

// function getPagedList(offset, max) {
//     return utilHelper.doRequest(`${relativeUrl}?max=${max}&offset=${offset}`, 'GET')
// }
//
// function getAll() {
//     return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
// }

function getRoutByActivity(data) {
    return utilHelper.doRequest(`${relativeUrl}/getRoutByActivity`, 'POST', data);
}

//search
function search(offset, max, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}

//show
function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', {})
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//delete
function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{})
}